import { render } from "./footer.vue?vue&type=template&id=ee46a27e"
const script = {}

import exportComponent from "D:\\online\\paramedicsuz_admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__